<template>
  <div>
    <v-data-table :headers="headers" :items="rawData" class="elevation-1" hide-actions>
      <template #items="props">
        <td>{{ props.item.intent || '-' }}</td>
        <td>
          {{ props.item.sent_survey_count }}
        </td>
        <td>
          {{ props.item.submit_survey_count }}
        </td>
        <td>
          <v-btn
            outline
            fab
            small
            color="primary"
            @click="handleShowScoreDetail(props.item.intent)"
          >
            <em class="fas fa-eye" style="font-size: 18px" />
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-layout row wrap justify-end class="mt-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>

    <v-dialog v-model="satisfactionScoreDialogOpen" persistent width="800px">
      <DialogSatisfactionScore
        v-if="satisfactionScoreDialogOpen"
        :date-filter="dateFilter"
        :intent-name="selectedIntent"
        @close="
          satisfactionScoreDialogOpen = false
          selectedIntent = null
        "
      />
    </v-dialog>
  </div>
</template>

<script>
import generaliApi from '@/api/generali'
import { mapGetters } from 'vuex'
import DialogSatisfactionScore from './DialogSatisfactionScore'

export default {
  components: {
    DialogSatisfactionScore
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pageNumber: 1,
      rowPerPage: 10,
      offset: 0,
      total: 0,
      rawData: [],
      headers: [
        { text: 'Intent name', value: 'intent', sortable: false },
        { text: 'จำนวนที่ส่งแบบประเมิน', value: 'sent_survey_count', sortable: false },
        { text: 'จำนวนที่ตอบกลับแบบประเมิน', value: 'submit_survey_count', sortable: false },
        { text: '', sortable: false }
      ],
      satisfactionScoreDialogOpen: false,
      selectedIntent: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageCount() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.rowPerPage)
      } else {
        return 1
      }
    },
    dateFilter() {
      return {
        start_date: this.filters.start_date,
        end_date: this.filters.end_date
      }
    }
  },
  watch: {
    filters: {
      handler() {
        this.handleFetchSatisfaction()
      },
      deep: true
    }
  },
  mounted() {
    this.handleFetchSatisfaction()
  },
  methods: {
    async handleFetchSatisfaction() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: vm.rowPerPage,
          offset: vm.offset,
          start_date: vm.filters.start_date,
          end_date: vm.filters.end_date
        }

        if (vm.filters && vm.filters.intent) {
          Object.assign(data, {
            intent: vm.filters.intent
          })
        }

        vm.$store.dispatch('loading')
        const response = await generaliApi.getCountIntentSatisfactionSurvey({
          config: {
            params: data
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          const responseData = response.data.data
          vm.rawData = responseData
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    handleChangePage(page) {
      this.pageNumber = page
      this.handleFetchSatisfaction()
    },
    handleShowScoreDetail(intentName) {
      this.selectedIntent = intentName
      this.satisfactionScoreDialogOpen = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/DataTable.vue